export default __webpack_public_path__ + "static/media/LL_LOGO.ee651de9.svg";